import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Select, Tooltip } from '@metarouter-private/mr-mui';
import { useQuerySampleEventNames } from '@ion/api';

import ConfirmLoadModal from './ConfirmLoadModal';
import useConfirmLoad from './useConfirmLoad';

export default function SampleEventSelect({ selectedSampleEventId, currentValue, loadSampleEvent }) {
  const { sampleEventNames, loading } = useQuerySampleEventNames();
  const { isConfirmModalOpen, requestLoad, confirmLoad, cancelLoad } = useConfirmLoad({
    loadSampleEvent,
    currentValue,
  });

  const options = sampleEventNames.map(({ id, name }) => ({ value: id, label: name }));

  const handleChange = useCallback(
    event => {
      const selectedId = event.target.value;
      if (selectedId) {
        requestLoad(selectedId);
      }
    },
    [requestLoad]
  );

  const isDisabled = loading || sampleEventNames.length === 0;
  const tooltipTitle = buildTooltipTitle({ loading, sampleEventNames });

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <span>
          <Select
            label="Sample Event"
            value={selectedSampleEventId ?? ''}
            options={options}
            onChange={handleChange}
            disabled={isDisabled}
            variant="outlined"
            size="small"
            data-test-id="sample-event-select"
            sx={{ minWidth: 200 }}
          />
        </span>
      </Tooltip>
      <ConfirmLoadModal open={isConfirmModalOpen} onConfirm={confirmLoad} onClose={cancelLoad} />
    </>
  );
}

SampleEventSelect.propTypes = {
  selectedSampleEventId: PropTypes.string,
  currentValue: PropTypes.string,
  loadSampleEvent: PropTypes.func.isRequired,
};

function buildTooltipTitle({ loading, sampleEventNames }) {
  if (loading) return 'Loading sample events...';
  if (sampleEventNames.length === 0) return 'No saved sample events';
  return '';
}
